export const chapters = [
    {
        id: 0,
        tags: {
            title: "I",
            description: "Глава I"
        },
        main: {
            title: "Рождение мастера",
            description: "История Александра Нестеренко началась не в Мастерской.\n\n" +
                "Его путь был связан с мотоспортом — миром точности, дисциплины и абсолютного контроля. После серьёзной аварии и долгого восстановления Александр открыл для себя искусство часового ремесла — работу, где терпение, инженерная мысль и мастерство рук становятся единым целым.\n\n" +
                "В 2014 году Александр начал профессионально создавать часы, постепенно формируя собственный взгляд на традиционное ремесло и авторский подход."
        },
        src: "/images/about/beginning.jpg",
    },
    {
        id: 1,
        tags: {
            title: "II",
            description: "Глава II"
        },
        main: {
            title: "Формирование почерка",
            description: "Не имея академического часового образования, Александр выбрал путь самостоятельного изучения: разбирая, исследуя и совершенствуя сложные механизмы.\n\n" +
                "Сегодня каждые часы Александра Нестеренко создаются как индивидуальное произведение.\n\n" +
                "Его работы вдохновлены архитектурой Санкт-Петербурга, эстетикой модерна и ар-деко. Узнаваемый почерк мастера - сложные многослойные циферблаты выполненные в технике гильоше, ручная работа и внимание к каждой детали."
        },
        src: "/images/about/signature.jpg",
    },
    {
        id: 2,
        tags: {
            title: "III",
            description: "Глава III"
        },
        main: {
            title: "Рождение Мануфактуры",
            description: "Работы Александра получили признание профессионального сообщества - трижды став победителями престижной награды «Лучшие российские часы» в 2022, 2023 и 2024 годах.\n\n" +
                "В 2023 году начался новый этап пути - Мануфактура Нестеренко.\n\n" +
                "Независимый часовой Дом, созданный вокруг философии мастерства, индивидуальности и уважения к традиционному ремеслу.\n\n" +
                "Мы создаем часы, которые становятся частью истории своего владельца."
        },
        src: "/images/about/manufacture.jpg",
    },
]